/*-----------------------------------------------------------------
- Blog routes
-----------------------------------------------------------------*/
const prefix = 'blog';
const routes = [
    {
        path     : `${prefix}`,
        name     : `${prefix}-list`,
        component: () => import('@/modules/blog/views/List.vue'),
    },
    {
        path     : `${prefix}/category/:url_encode/:slug?`,
        name     : `${prefix}-category`,
        component: () => import('@/modules/blog/views/List.vue'),
    },
    {
        path     : `${prefix}/tag/:url_encode/:slug?`,
        name     : `${prefix}-tag`,
        component: () => import('@/modules/blog/views/List.vue'),
    },
    {
        path     : `${prefix}/:url_encode/:slug?`,
        name     : `${prefix}-single`,
        component: () => import('@/modules/blog/views/Single.vue'),
    },
];

export default routes;
